import { StackActions, useNavigation } from "@react-navigation/native";
import React, { useCallback, useEffect, useState } from "react";
import { View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch, useSelector } from "react-redux";
import { Icon, Loading, Text, TouchableWithEffect } from "@edgelogistics/edge-ui/lib/components";
import UserCard from "./components/UserCard";
import { styles } from "./styles";
import { userSelector } from "../../redux/auth/authSelector";
import { profileSelector } from "../../redux/profile/profileSelector";
import { getUserInformation } from "../../redux/profile/profileActions";
import EditUser from "./components/EditUser";
import ChangePassword from "./components/ChangePassword";

const ProfileScreen: React.FC = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const { userInformationLoading } = useSelector(profileSelector);
  const { top: paddingTop = 0 } = useSafeAreaInsets();
  const { user = {} } = useSelector(userSelector);
  const [ openEditUser, setOpenEditUser ] = useState(false);
  const [ openChangePassword, setOpenChangePassword ] = useState(false);

  const onGoBack = useCallback(() => {
    navigation.canGoBack() ? navigation.goBack() : navigation.dispatch(StackActions.replace("main"));
  }, [ navigation ]);

  useEffect(() => {
    dispatch(getUserInformation());
  }, [ dispatch ]);

  return (
    <View style={[ styles.container, { paddingTop } ]}>
      <View style={styles.header}>
        <View style={styles.title}>
          <TouchableWithEffect
            onPress={onGoBack}
            style={{
              width          : 30,
              height         : 30,
              justifyContent : "center",
              alignItems     : "center",
              borderRadius   : 999,
            }}
            testID="profileGoBackArrow"
          >
            <Icon name="LeftArrow" width={18} height={18} />
          </TouchableWithEffect>
          <Text text="My Profile" style={{ fontSize: 18, fontWeight: "bold", marginLeft: 20 }} />
        </View>
        <Icon name="NewEdgeLogo" height={50} width={200} />
      </View>
      <View style={styles.info}>
        {userInformationLoading ? (
          <Loading containerStyle={styles.loading} />
        ) : (
          <UserCard
            user={user}
            handleEditUser={() => setOpenEditUser(true)}
            handleChangePassword={() => setOpenChangePassword(true)}
          />
        )}
      </View>
      {/**  @ts-expect-error */}
      <EditUser open={openEditUser} handleClose={() => setOpenEditUser(false)} user={user} />
      {/**  @ts-expect-error */}
      <ChangePassword open={openChangePassword} handleClose={() => setOpenChangePassword(false)} user={user} />
    </View>
  );
};

export default ProfileScreen;
